import { Outlet } from "react-router-dom";

const DeliveriesPage = () => {
  return <Outlet />;
};

export default DeliveriesPage;
